import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import styles from './TitleText.module.scss';

interface Props {
  text: string;
  id?: string;
  type?: 'title' | 'sectionTitle';
  visuallyHidden?: boolean;
  /** Drops the standalone block margins when the caller (BlockHeading) owns the spacing. */
  flush?: boolean;
}
export function TitleText(props: Props) {
  const { text, id, type = 'title', visuallyHidden, flush } = props;
  const [scrollMarginTop, setScrollMarginTop] = useState({});

  useEffect(() => {
    let newTop = 10;
    const header = document.querySelector('header');
    const tabNavigation = document.querySelector('#tabNavigation');
    if (header) {
      newTop += header.getBoundingClientRect().height;
    }
    if (tabNavigation) {
      newTop += tabNavigation.getBoundingClientRect().height;
    }
    setScrollMarginTop({ scrollMarginTop: `${newTop}px` });
  }, [id]);

  if (type === 'title') {
    return (
      <h2
        className={classNames('h5', {
          [styles.title]: type === 'title',
          [styles.flush]: flush,
        })}
        id={id}
        style={scrollMarginTop}
      >
        {text}
      </h2>
    );
  }

  if (type === 'sectionTitle') {
    return (
      <h2
        className={classNames('h5', {
          [styles.sectionTitle]: type === 'sectionTitle',
          [styles.srOnly]: visuallyHidden,
        })}
        id={id}
        style={scrollMarginTop}
      >
        {text}
      </h2>
    );
  }

  return null;
}
